import React     from 'react'
import BigNumber from 'bignumber.js'

import { Table, Button, Glyphicon } from 'react-bootstrap'

import './table.sass'

export default class TransactionTable extends React.Component
  constructor: (props, context) ->
    super(props, context)

    @state = { showDetailsFor: null }

  render: ->
    <Table striped hover responsive id="transaction-table" className='one-action'>
      <thead>{@header()}</thead>
      <tbody>{@props.transactions.map(@row.bind(@))}</tbody>
    </Table>

  header: ->
    <tr>
      <th>Datum a čas</th>
      <th>Číslo účtu</th>
      <th>Typ</th>
      <th>Obnos</th>
      <th>Zůstatek</th>
      <th className='detail-column'></th>
    </tr>

  row: (transaction) ->
    showDetail   = transaction.id == @state.showDetailsFor
    onClick      = => @setState(showDetailsFor: if showDetail then null else transaction.id)
    detailButton = if transaction.billHeaderID
      <Button bsSize='xs' onClick={onClick}>
        Detail&ensp;<Glyphicon glyph={if showDetail then 'minus' else 'plus'} />
      </Button>

    transactionRow =
      <tr key={transaction.id}>
        <td key='transactedAt'>{transaction.transactedAt.locale('cs').format('LLL')}</td>
        <td key='description'>{transaction.description}</td>
        <td key='humanKind'>{transaction.humanKind}</td>
        <td key='amount' >{transaction.amount.toFixed(2)}</td>
        <td key='balance'>{transaction.balance.toFixed(2)}</td>
        <td key='detail' className='detail-column'>{detailButton}</td>
      </tr>

    if showDetail
      detailRow =
        <tr><td colSpan={6} className='transaction-detail-row'>
          {@detailFor(transaction)}
        </td></tr>

      <React.Fragment key={transaction.id}>
        {transactionRow}
        {detailRow}
      </React.Fragment>
    else
      transactionRow

  detailFor: (transaction) ->
    header = transaction.associations.billHeader
    items  = header.associations.items
    sum    = items.reduce(((sum, item) -> sum.plus(item.prachy)), new BigNumber(0)).toFixed(2)

    <Table condensed>
      <thead>
        <tr>
          <th>Název položky</th>
          <th>Množství</th>
          <th>Jednotková cena</th>
          <th>Cena za množství</th>
        </tr>
      </thead>

      <tbody>
        {items.map(@detailRowFor)}

        <tr>
          <th>Celková suma</th>
          <th />
          <th />
          <th>{sum}</th>
        </tr>
      </tbody>
    </Table>

  detailRowFor: (item) ->
    <tr key={item.id}>
      <td>{item.associations.product.name}</td>
      <td>{item.mnozstvi.toString()}</td>
      <td>{item.prachy.div(item.mnozstvi).decimalPlaces(2).toFixed(2)}</td>
      <td>{item.prachy.toFixed(2)}</td>
    </tr>
